"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";

export function ScrollReset() {
  const pathname = usePathname();
  const poppedRef = useRef(false);
  const positionsRef = useRef<Map<string, number>>(new Map());
  const keyRef = useRef("");

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    const onPopState = () => {
      poppedRef.current = true;
    };
    const onScroll = () => {
      positionsRef.current.set(keyRef.current, window.scrollY);
    };
    window.addEventListener("popstate", onPopState);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("popstate", onPopState);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  useEffect(() => {
    const key = pathname + window.location.search;
    keyRef.current = key;

    if (poppedRef.current) {
      poppedRef.current = false;
      const target = positionsRef.current.get(key);
      if (target != null) {
        let tries = 0;
        const restore = () => {
          window.scrollTo(0, target);
          if (window.scrollY < target - 1 && tries < 20) {
            tries += 1;
            requestAnimationFrame(restore);
          }
        };
        requestAnimationFrame(restore);
      }
      return;
    }

    if (window.location.hash) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
